export default class LocationList {
    openLocation = false;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('locationList', () => new LocationList());
});